<template>
  <div class="d-flex flex-column justify-content-center align-items-center mb-3" :class="[typeof $store.getters.getNotificationBar.is_message !== 'undefined' && $store.getters.getNotificationBar.is_message === true && !$store.getters.getNotificationBarClosedIds.includes($store.getters.getNotificationBar.id) ? 'min-vh-20': 'flex-grow-1 min-h-px-80 max-vh-20']">
    <!-- notification bar -->
    <div role="alert" class="d-flex w-100 mb-3 bg-blue pt-3 pb-3 pl-4 pr-4 position-absolute position-top-0 header-notification-z" v-if="($router.enableNotificationBarRoutes.includes($route.name) || $store.getters.getMeetingDisconnectedAs === 'agent' || $store.getters.getMeetingEndedAs === 'agent' || $store.getters.getUser !== false) && typeof $store.getters.getNotificationBar.is_message !== 'undefined' && $store.getters.getNotificationBar.is_message === true && !$store.getters.getNotificationBarClosedIds.includes($store.getters.getNotificationBar.id) && $root.isAppReconnecting === false">

      <p class="mr-3"><span v-html="sanitizedNotificationMessage"></span> <strong>| <a href="#" @click.prevent="closeNotificationBar($store.getters.getNotificationBar.id)">{{ $t('Header.Close message') }}</a></strong></p>

      <img v-if="$store.getters.getNotificationBar.message_type === 'informational'" class="d-flex ml-auto mt-auto mb-auto" src="../assets/info.svg" alt="Info">
      <img v-if="$store.getters.getNotificationBar.message_type === 'announcement'" class="d-flex ml-auto mt-auto mb-auto" src="../assets/announcement.svg" alt="Announcement">
      <img v-if="$store.getters.getNotificationBar.message_type === 'issue'" class="d-flex ml-auto mt-auto mb-auto" src="../assets/error.svg" alt="Issue">
    </div>

    <!-- reconnecting app -->
    <component :is="reconnectingComponent"></component>

    <!-- logo -->
    <div class="d-flex justify-content-center mt-auto" v-if="$store.getters.getProduct === 'direct' || $route.name !== 'meeting' || $store.getters.getUser !== false || $store.getters.getMeetingEndedAs === 'agent' || $store.getters.getMeetingDisconnectedAs === 'agent'">
      <img v-if="$store.getters.getUser === false && $store.getters.getMeeting !== false && typeof $store.getters.getMeeting.site !== 'undefined' && typeof $store.getters.getMeeting.site.logo !== 'undefined' && $store.getters.getMeeting.site.logo !== null" :src="$store.getters.getMeeting.site.logo" class="custom_logo" alt="Logo" />
      <img v-else-if="$store.getters.getUser !== false && typeof $store.getters.getUser.entity.logo !== 'undefined' && $store.getters.getUser.entity.logo !== null && typeof $store.getters.getUser.entity.custom_domain !== 'undefined' && $store.getters.getUser.entity.custom_domain === true && !hostname.includes('weseedo.nl')" :src="$store.getters.getUser.entity.logo" class="custom_logo" alt="Logo" />
      <img v-else-if="hostname.includes('weseedo.nl') || hostname.includes('localhost')" src="../assets/logo-weseedo.svg" class="logo"  alt="WeSeeDo logo" />
    </div>
    <span class="d-block mt-2 font-size-rem-13" v-if="['home', 'login', 'auto_login', 'forgot_password', 'reset_password', 'activate_account'].includes($route.name) && (hostname.includes('weseedo.nl') || hostname.includes('localhost'))">
      <template v-if="$store.getters.getProduct === 'direct'">{{ $t('Login.Direct') }}</template>
    </span>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import { sanitizeRichHtml } from '../utils/sanitize'

export default {
  name: 'Header',
  data () {
    return {
      hostname: '',
      countdown: 30,
      autoCloseTimer: null,
      countdownInterval: null,
      previousNotificationId: null
    }
  },
  methods: {
    clearTimers () {
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer)
        this.autoCloseTimer = null
      }
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval)
        this.countdownInterval = null
      }
    },
    closeNotificationBar (id) {
      // Stop timers to avoid race conditions
      this.clearTimers()
      this.$store.commit('addNotificationBarClosedId', id)
    },
    startAutoCloseTimer (id) {
      console.log(id)
      this.clearTimers()
      this.countdown = 30

      // Visual countdown timer
      this.countdownInterval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          this.clearTimers()
        }
      }, 1000)
      this.autoCloseTimer = setTimeout(() => {
        try {
          if (!this.$store.getters.getNotificationBarClosedIds.includes(id)) {
            this.closeNotificationBar(id)
          }
        } catch (err) {
          console.error('Timer error:', err)
        }
      }, 10000)
    }
  },
  components: {
    reconnecting: defineAsyncComponent(() => import('./Reconnecting.vue'))
  },
  computed: {
    reconnectingComponent () {
      return 'reconnecting'
    },
    progressBarWidth () {
      return (this.countdown / 30) * 100
    },
    sanitizedNotificationMessage () {
      const msg = this.$store.getters.getNotificationBar?.message
      return msg ? sanitizeRichHtml(msg) : ''
    }
  },
  mounted () {
    this.hostname = window.location.hostname
  },
  beforeUnmount () {
    this.clearTimers()
  },
  watch: {
    '$store.getters.getNotificationBar': {
      handler (newVal) {
        const id = newVal?.id
        const isOpen = newVal?.is_message === true &&
        !this.$store.getters.getNotificationBarClosedIds.includes(id)
        if (
          isOpen && id !== this.previousNotificationId
        ) {
          this.previousNotificationId = id
          this.startAutoCloseTimer(newVal.id)
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.header-notification-z {
  z-index: 101 !important;
}

</style>
